module.exports = __webpack_public_path__ + "img/screen6.d2a2119.png";